import * as React from "react";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Modal, Input, Typography, message } from "antd";
import {
    WhatsAppOutlined,
    CopyOutlined,
    LinkedinOutlined,
} from "@ant-design/icons";
import WalletIcon from "src/static/images/wallet-icon.png";
import { useContext, useEffect, useMemo, useState } from "react";
import { UserContext } from "src/hooks/context/userInfo";
import { RestApiClientContext } from "src/hooks/context/pageContext";
import { useCurrentUserLanguage } from "src/api/api";
import { AppRoute } from "src/routes/appLanguages";
import { appStrings } from "src/routes/localizations";
import { FirstReward } from "../rewardBalance/rewardBalance";
import { useTranslation } from "react-i18next";
import ReactHtmlParser from "react-html-parser";
import XIcon from "src/static/images/icons/XIcon";
const { Text, Paragraph } = Typography;

export default function RewardReferral() {
    const restApiClient = useContext(RestApiClientContext);
    const { t } = useTranslation(["urls", "reward"]);
    const userlang = useCurrentUserLanguage();

    const [statusReferral, setStatusReferral] = useState<boolean>(false);
    const [referralReward, setReferralReward] = useState<FirstReward[]>(null);
    const [shareReferralModal, setShareReferralModal] = useState(false);
    const [linkRefered, setLinkRefered] = useState<string>(`${window.location.host.replace(".com", "")}/${"es" + appStrings["es"][AppRoute.Register]}`);

    const mensaje = useMemo(() => `${t('reward:referral.register-message', { web: window.location.origin })} ${linkRefered}`, [linkRefered]);
    const mensajeEncoded = useMemo(() => encodeURIComponent(`${t('reward:referral.register-message-part-1')} ${window.location.origin} ${t('reward:referral.register-message-part-2')} ${linkRefered}`), [linkRefered]);
    const userContext = useContext(UserContext);
    const firstRewardFiltered = useMemo(() => referralReward?.filter(x => x.idCurrency == userContext.GetCurrency() || x.idCurrency == null), [referralReward]);

    const copiarTexto = async () => {
        try {
            await navigator.clipboard.writeText(linkRefered);
            message.success("Texto copiado al portapapeles");
        } catch (err) {
            message.error("No se pudo copiar el texto");
        }
    };
    useEffect(() => {
        restApiClient.getRewardsReferralAmounts().then((response) => {
            setReferralReward(response)
        })
        restApiClient.getStatusReferral().then((response) => {
            setStatusReferral(response)
        })
    }, [])
    useEffect(() => {
        setLinkRefered(`${window.location.origin}/${userlang.shortId + appStrings[userlang.shortId][AppRoute.Register]}?referralCode=${userContext?.GetReferalCode()}`);
    }, [userlang]);
    return <>
        {statusReferral && firstRewardFiltered != null &&
            referralReward != null &&
            firstRewardFiltered.length > 0 &&
            ((firstRewardFiltered?.find(x => x.type == "REFERRER")?.amount ?? 0) > 0 ||
                (firstRewardFiltered?.find(x => x.type == "REFERRED")?.amount ?? 0) > 0) &&
            <div style={{ backgroundColor: 'white', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '25px 35px', marginBottom: '20px' }} className="col-12">
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', gap: '20px' }}>
                    <img style={{ height: '100%', minWidth: '50px' }} src={WalletIcon} />
                    <div>
                        <Text className="font-size">{t('reward:referral.title')}</Text>
                        <Paragraph style={{ margin: '0' }}> {t('reward:referral.share-message')}</Paragraph>
                    </div>
                </div>
                <Button onClick={() => setShareReferralModal(true)}>{t('reward:referral.share')}</Button>
            </div>}
        <Modal title={t('reward:referral.share-to-win')} visible={shareReferralModal}
            footer={null}
            closable
            centered
            onCancel={() => setShareReferralModal(false)}
        >
            <Paragraph>
                {t('reward:referral.share-message')}
            </Paragraph>
            {

                <Paragraph>

                    {ReactHtmlParser(t('reward:referral.share-message-money', {
                        referrer: firstRewardFiltered?.find(x => x.type == "REFERRER")?.amount || 0,
                        referred: firstRewardFiltered?.find(x => x.type == "REFERRED")?.amount || 0,
                        currencyReferrer: (firstRewardFiltered?.find(x => x.type == "REFERRER")?.amountType == "fixed" ? firstRewardFiltered?.find(x => x.type == "REFERRER")?.idCurrency : "%") || "",
                        currencyReferred: (firstRewardFiltered?.find(x => x.type == "REFERRED")?.amountType == "fixed" ? firstRewardFiltered?.find(x => x.type == "REFERRED")?.idCurrency : "%") || ""
                    }))}
                </Paragraph>}
            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center' }}>
                <Button
                    type="primary"
                    size="large"
                    href={`mailto:?subject=${encodeURIComponent(`${t('reward:referral.share-to-win-subject')}`)}&body=${mensajeEncoded}`}
                    icon={<FontAwesomeIcon icon={faEnvelope} />}
                    target="_blank"

                />
                <Button
                    style={{ backgroundColor: '#0a66c2' }}
                    type="primary"
                    size="large"
                    href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(linkRefered)}`}
                    icon={<LinkedinOutlined />}
                    target="_blank"

                />

                <Button
                    style={{ backgroundColor: '#454545' }}
                    type="primary"
                    size="large"
                    href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(
                        mensaje
                    )}`}

                    icon={<span role="img" className="anticon">
                        <XIcon/>
                    </span>}
                    target="_blank"

                />
                <Button
                    size="large"
                    style={{ backgroundColor: "#25D366", borderColor: "#25D366", color: "#fff" }}
                    icon={<WhatsAppOutlined />}
                    href={`https://api.whatsapp.com/send?text=${encodeURIComponent(mensaje)}`}
                    target="_blank"

                />
                <Input.Group style={{ display: 'flex' }} compact>
                    <Input value={linkRefered} readOnly />
                    <Button icon={<CopyOutlined />} onClick={copiarTexto} type="primary" />
                </Input.Group>

            </div>
        </Modal>
    </>
}